import { useState, useCallback } from "react";

interface ModalConfig {
  [key: string]: {
    component: React.ComponentType<any>;
    title: string;
  };
}

export const useModal = (config: ModalConfig) => {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const [modalProps, setModalProps] = useState<any>({});

  const openModal = useCallback(
    (modalKey: string, props: any = {}) => {
      if (config[modalKey]) {
        setActiveModal(modalKey);
        setModalProps(props);
      } else {
        console.warn(`Modal with key "${modalKey}" not found in config.`);
      }
    },
    [config]
  );

  const closeModal = useCallback(() => {
    setActiveModal(null);
    setModalProps({});
  }, []);

  return { activeModal, modalProps, openModal, closeModal };
};
